import React, { Component } from 'react';
import { classNames } from '@philips-internal/oswald-ui-utils';
class SlideUpPanelHeader extends Component {
    getClassNames() {
        const { className } = this.props;
        return classNames({
            'c-slide-up-panel__header': true,
            [`${className}`]: Boolean(className),
        });
    }
    renderTitle() {
        const { title } = this.props;
        if (!title) {
            return null;
        }
        return React.createElement("div", { className: "c-slide-up-panel__header__title" }, title);
    }
    render() {
        const { children } = this.props;
        return (React.createElement("div", { className: this.getClassNames() },
            this.renderTitle(),
            children));
    }
}
export { SlideUpPanelHeader, };
//# sourceMappingURL=slide-up-panel-header.js.map